import { useGetSettingsQuery } from '@api/api';
import { DataLoadingProgress, GenericErrorPage } from '@components';

export type SiteContentLoaderProps = {
  children?: React.ReactNode;
};

/**
 * Site Content Loader.
 * Load Site Settings before displaying any other content
 * Site Settings are intercepted and saved in the app.slice extra reducer.
 * Display Generic Error page when content can't be loaded.
 */
export const SiteContentLoader = ({ children }: SiteContentLoaderProps) => {
  const settings = useGetSettingsQuery(null);
  const { isLoading, isSuccess, isError } = settings;
  return (
    <>
      {isLoading && <DataLoadingProgress />}
      {isError && <GenericErrorPage />}
      {isSuccess && children}
    </>
  );
};
